module.exports = __webpack_public_path__ + "img/icon-xz2.cbf4167c.png";